'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UI_TOGGLE_SITEMAP = exports.UI_TOGGLE_SECTION = exports.UI_TOGGLE_MAIN_MENU = exports.UI_INIT = exports.UI_GENERATE_SUBSECTIONS_STATE = undefined;

var _actionNamePrefixer = require('../actionNamePrefixer');

var _actionNamePrefixer2 = _interopRequireDefault(_actionNamePrefixer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UI_GENERATE_SUBSECTIONS_STATE = exports.UI_GENERATE_SUBSECTIONS_STATE = (0, _actionNamePrefixer2.default)('UI_GENERATE_SUBSECTIONS_STATE');
var UI_INIT = exports.UI_INIT = (0, _actionNamePrefixer2.default)('UI_INIT');
var UI_TOGGLE_MAIN_MENU = exports.UI_TOGGLE_MAIN_MENU = (0, _actionNamePrefixer2.default)('UI_TOGGLE_MAIN_MENU');
var UI_TOGGLE_SECTION = exports.UI_TOGGLE_SECTION = (0, _actionNamePrefixer2.default)('UI_TOGGLE_SECTION');
var UI_TOGGLE_SITEMAP = exports.UI_TOGGLE_SITEMAP = (0, _actionNamePrefixer2.default)('UI_TOGGLE_SITEMAP');
//# sourceMappingURL=types.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/redux/core-navigation-ui/types.js
 ** module id = 120
 ** module chunks = 1
 **/